import { Badge, Box, Button, Checkbox, Divider, Flex, Grid, Group, Input, Modal, SegmentedControl, Text, Tooltip } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import { IconFileDollar } from "@tabler/icons";
import React, { useId } from "react";
import { IMaskInput } from "react-imask";
import { useSelector } from "react-redux";
import { LbfLimit } from "../../apis";
import { IGeneral } from "../../interfaces/IGeneral";
import { ILimit } from "../../interfaces/ILimit";
import { IReference } from "../../models/General";
import { ColumnType, ITableRef, Table } from "../table";
import RenderText from "../ui/render-text";
import { BuyerLedForm } from "./form";

const anchorData = [
  {
    name: "Бүгд",
    code: "",
    color: "yellow",
  },
  {
    name: "Тийм",
    color: "green",
    code: `${true}`,
  },
  {
    name: "Үгүй",
    color: "pink",
    code: `${false}`,
  },
];

export function BuyerLedLimit() {
  const ref = React.useRef<ITableRef>(null);
  const [action, setAction] = React.useState<string[]>([]);
  const { lbfProgramStatus } = useSelector((state: { general: IGeneral }) => state.general);
  const [regNumber, setRegNumber] = React.useState("");
  const [debouncedRegNumber] = useDebouncedValue(regNumber, 600);
  const [clientName, setClientName] = React.useState("");
  const [debouncedClientName] = useDebouncedValue(clientName, 600);
  const [clientCode, setClientCode] = React.useState("");
  const [debouncedClientCode] = useDebouncedValue(clientCode, 600);
  const [programName, setProgramName] = React.useState("");
  const [debouncedProgramName] = useDebouncedValue(programName, 600);
  const [anchor, setAnchor] = React.useState("");
  const [debouncedAnchor] = useDebouncedValue(anchor, 600);
  const [programStatus, setProgramStatus] = React.useState("");
  const [debouncedProgramStatus] = useDebouncedValue(programStatus, 600);
  const id = useId();

  const columns = useHeader({
    lbfProgramStatus,
    onClick: (key, record) => {
      switch (key) {
        case "limit": {
          setAction(["limit", record.clientRegNumber]);
          break;
        }
      }
    },
  });

  const onCancel = async () => {
    setAction([]);
  };

  const onChangeReg = (e: string) => {
    if (e.length === 7 || e.length === 0) {
      setRegNumber(e);
    }
  };

  return (
    <>
      <Grid>
        <Grid.Col span={3}>
          <Input.Wrapper
            id={id}
            onChange={(e: any) => {
              onChangeReg(e.target.value);
            }}>
            <Input<any>
              component={IMaskInput}
              mask="0000000"
              id={id}
              iconWidth={80}
              placeholder="хайх"
              style={{ borderRight: "none", borderRadius: "4px 0 0 4px" }}
              icon={
                <Group w={"calc(100% - 20px)"} align="center" position="apart" noWrap>
                  <Text size="sm" weight={450} c="#44566C">
                    {"ТТД"}
                  </Text>
                  <Text>:</Text>
                </Group>
              }
            />
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col span={3}>
          <Input
            value={clientName}
            iconWidth={150}
            placeholder="хайх"
            maxLength={45}
            style={{ borderRight: "none", borderRadius: "4px 0 0 4px" }}
            icon={
              <Group w={"calc(100% - 20px)"} align="center" position="apart" noWrap>
                <Text size="sm" weight={450} c="#44566C">
                  {"Харилцагч нэр"}
                </Text>
                <Text>:</Text>
              </Group>
            }
            onChange={(e) => {
              setClientName(e.currentTarget.value);
            }}
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <Input
            value={clientCode}
            iconWidth={80}
            placeholder="хайх"
            maxLength={45}
            style={{ borderRight: "none", borderRadius: "4px 0 0 4px" }}
            icon={
              <Group w={"calc(100% - 20px)"} align="center" position="apart" noWrap>
                <Text size="sm" weight={450} c="#44566C">
                  {"CIF"}
                </Text>
                <Text>:</Text>
              </Group>
            }
            onChange={(e) => {
              setClientCode(e.currentTarget.value);
            }}
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <Input
            value={programName}
            iconWidth={140}
            placeholder="хайх"
            maxLength={100}
            style={{ borderRight: "none", borderRadius: "4px 0 0 4px" }}
            icon={
              <Group w={"calc(100% - 20px)"} align="center" position="apart" noWrap>
                <Text size="sm" weight={450} c="#44566C">
                  {"Хөтөлбөр нэр"}
                </Text>
                <Text>:</Text>
              </Group>
            }
            onChange={(e) => {
              setProgramName(e.currentTarget.value);
            }}
          />
        </Grid.Col>

        <Grid.Col span={3}>
          <Flex justify="flex-start" align="flex-start" direction="column" wrap="wrap" key={1}>
            <Text size="sm" weight={450} c="#44566C">
              Anchor
            </Text>
            <SegmentedControl
              onChange={(e) => setAnchor(e)}
              value={anchor}
              data={(anchorData || []).map((item: any, index: number) => {
                return {
                  value: item.code || "",
                  label: (
                    <Badge variant="dot" color={item.color} style={{ border: "none" }} key={`${index}`}>
                      {item.name}
                    </Badge>
                  ),
                };
              })}
            />
          </Flex>
        </Grid.Col>
        <Grid.Col span={3}>
          <Flex justify="flex-start" align="flex-start" direction="column" wrap="wrap" key={1}>
            <Text size="sm" weight={450} c="#44566C">
              Хөтөлбөр статус
            </Text>
            <SegmentedControl
              onChange={(e) => setProgramStatus(e)}
              value={programStatus}
              data={[{ name: "Бүгд", code: "", color: "yellow" }, ...(lbfProgramStatus || [])]
                .filter((c: IReference) => c.code !== "CLOSED" && c.code !== "CANCELLED")
                .map((item: IReference, index: number) => {
                  return {
                    value: item.code || "",
                    label: (
                      <Badge variant="dot" color={item.color} style={{ border: "none" }} key={`${index}`}>
                        {item.name}
                      </Badge>
                    ),
                  };
                })}
            />
          </Flex>
        </Grid.Col>
        <Grid.Col span={3}></Grid.Col>
        <Grid.Col span={3}></Grid.Col>

        <Grid.Col span={12}>
          <Divider />
        </Grid.Col>
      </Grid>
      <Table
        ref={ref}
        name="lbf-buyer-led-limit.list"
        columns={columns}
        filters={{
          lbfProductType: "BUYER_LED",
          clientCode: debouncedClientCode,
          clientRegNumber: debouncedRegNumber,
          clientName: debouncedClientName,
          isAnchor: debouncedAnchor,
          lbfProgramName: debouncedProgramName,
          lbfProgramStatus: debouncedProgramStatus,
        }}
        loadData={(data) => LbfLimit.list(data!)}
      />
      <Modal opened={action[0] === "limit"} onClose={() => setAction([])} withCloseButton={false} centered size="60%">
        <BuyerLedForm action={action} onCancel={onCancel} title="Байгууллагын лимит" subTitle="Buyer - LED байгууллагын лимитийн дэлгэрэнгүй" />
      </Modal>
    </>
  );
}

const useHeader = ({ onClick, lbfProgramStatus }: { onClick: (key: string, record: ILimit) => void; lbfProgramStatus: IReference[] }): ColumnType<ILimit>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => {
      return <RenderText text={index + 1} />;
    },
  },
  {
    title: "Үйлдэл",
    render: (record) => {
      return (
        <Tooltip label="Лимит" position="bottom">
          <Button variant="light" radius={100} w={35} h={35} p={0} onClick={() => onClick("limit", record)}>
            <IconFileDollar />
          </Button>
        </Tooltip>
      );
    },
  },
  {
    title: "CIF",
    sorter: true,
    dataIndex: "name",
    render: (record) => {
      return <RenderText text={record?.clientCode || "-"} />;
    },
  },
  {
    title: "ТТД",
    sorter: true,
    dataIndex: "name",
    render: (record) => {
      return <RenderText text={record?.clientRegNumber || "-"} />;
    },
  },
  {
    title: "Харилцагчийн нэр",
    sorter: true,
    dataIndex: "name",
    render: (record) => {
      return (
        <Box>
          <RenderText text={record?.business?.profileName || "-"} />
          <RenderText text={record?.business?.refCode || "-"} />
        </Box>
      );
    },
  },
  {
    title: "Supplier",
    sorter: true,
    dataIndex: "name",
    render: (record) => {
      const isSupplier = !record.isBuyer;
      const label = isSupplier ? "Тийм" : "Үгүй";
      return <Checkbox checked={isSupplier} label={label} size="sm" onChange={() => {}} />;
    },
  },
  {
    title: "Buyer",
    sorter: true,
    dataIndex: "name",
    render: (record) => {
      const isBuyer = record.isBuyer;
      const label = isBuyer ? "Тийм" : "Үгүй";
      return <Checkbox checked={isBuyer} label={label} size="sm" onChange={() => {}} />;
    },
  },
  {
    title: "Anchor",
    sorter: true,
    dataIndex: "name",
    render: (record) => {
      const isAnchor = record.isAnchor;
      const label = isAnchor ? "Тийм" : "Үгүй";
      return <Checkbox checked={isAnchor} label={label} size="sm" onChange={() => {}} />;
    },
  },
  {
    title: "Хөтөлбөрийн нэр",
    sorter: true,
    dataIndex: "name",
    render: (record) => {
      return (
        <Box>
          <RenderText text={record?.lbfProgramName || "-"} />
          <RenderText text={record?.lbfProgramRefCode || "-"} color="#3e166e" />
        </Box>
      );
    },
  },
  {
    title: "Хөтөлбөр статус",
    sorter: true,
    dataIndex: "name",
    render: (record) => {
      return (
        <Badge
          size="md"
          radius="sm"
          variant="outline"
          color={(lbfProgramStatus || []).find((item: IReference) => item.code === record.lbfProgramStatus)?.color}>
          {(lbfProgramStatus || []).find((item: IReference) => item.code === record.lbfProgramStatus)?.name ?? "-"}
        </Badge>
      );
    },
  },
];
